import { combineReducers } from "redux";
import example from "./example";
import profile from "./profile";
import transactions from "./transactions";



export default combineReducers({
   // reducers here
   transactions,
   profile,
   example
});